import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import { RenderNode } from '@contentful/rich-text-react-renderer';

import { Column } from '../Layout';
import RichText from '../RichText';

import { AdditionalContentWrapper, StyledIcon } from './styles';

import { getImageData } from '../../utils/contentful';
import { Flexbox } from '../Flexbox';
import { IFullwidthHero20Fields } from '@/types/contentful';
import { ParagraphWithLineBreaks } from '../RichText/styles';

type AdditionalTextProps = Pick<IFullwidthHero20Fields, 'additionalText'>;

const RICH_TEXT_OVERRIDE: RenderNode = {
  [BLOCKS.PARAGRAPH]: (_node, children) => {
    return (
      <ParagraphWithLineBreaks
        as="p"
        fontSize={{
          0: '2xs',
          tablet: 's'
        }}
        fontWeight="400"
        colour="defaultText"
        textAlign="left"
      >
        {children}
      </ParagraphWithLineBreaks>
    );
  },
  [BLOCKS.EMBEDDED_ASSET]: (node) => (
    <StyledIcon {...getImageData(node.data.target)} />
  )
};

export const AdditionalText = ({ additionalText }: AdditionalTextProps) => {
  return (
    <Column size={10} margin={0}>
      <Flexbox
        flexDirection="row"
        justifyContent="space-between"
        margin={0}
        alignItems="left"
      >
        <AdditionalContentWrapper data-e2e="additional-content-container">
          <RichText
            data={additionalText}
            overrideOptions={RICH_TEXT_OVERRIDE}
          />
        </AdditionalContentWrapper>
      </Flexbox>
    </Column>
  );
};
